import { Subject } from 'rxjs';

const subject = new Subject();

export const deleteTopicService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};